import { render, staticRenderFns } from "./QScoreCardNewRecruits.vue?vue&type=template&id=d53ed4e0&scoped=true&"
import script from "./QScoreCardNewRecruits.vue?vue&type=script&lang=js&"
export * from "./QScoreCardNewRecruits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53ed4e0",
  null
  
)

export default component.exports